import { Chip } from "@mui/material";
import { ChemicalConstraint, ChemicalElement } from "store/api/generatedApi";
import { chemicalExpressionFromConstraintCoefficients } from "../constraints/chemicalExpressionFromConstraintCoefficients";

export const formatConstraint = (
  expression: string,
  minPercent: number | null | undefined,
  maxPercent: number,
  format?: (value: number) => string,
  units?: string
) => {
  format = format ?? ((value) => value.toPrecision(2));
  units = units ?? "%";
  if (minPercent && maxPercent < 100) {
    return `${format(minPercent)}${units} ≤ ${expression} ≤ ${format(
      maxPercent
    )}${units}`;
  } else if (minPercent) {
    return `${format(minPercent)}${units} ≤ ${expression}`;
  } else if (maxPercent < 100) {
    return `${expression} ≤ ${format(maxPercent)}${units}`;
  }
  return `${expression} ≤ ${format(maxPercent)}${units}`;
};
/**
 * Shows each of a series of chemistry constraints in small panels.
 */
export const ChemicalConstraints = ({
  chemicalConstraints,
  elements,
}: {
  chemicalConstraints: ChemicalConstraint[];
  elements: Record<number, ChemicalElement>;
}) => {
  return (
    <>
      {chemicalConstraints
        .filter(
          (constraint) =>
            (constraint.weight_percent_min !== undefined &&
              constraint.weight_percent_min !== null &&
              constraint.weight_percent_min > 0) ||
            constraint.weight_percent_max < 100
        )
        .map((constraint) => {
          const expression = chemicalExpressionFromConstraintCoefficients(
            constraint.name,
            constraint.coefficients,
            elements
          );
          return (
            <Chip
              label={formatConstraint(
                expression,
                constraint.weight_percent_min,
                constraint.weight_percent_max
              )}
              size="small"
              key={expression}
            />
          );
        })}
    </>
  );
};
